//**auto-generated don't edit this code**//
export enum TestScreenType {
	None,
	OneToOne,
	SelfAssessment,
}